import { use } from "react";
import { DeskViewContext } from "./DeskViewContext";
import type { DeskViewValue } from "./DeskViewContext";

export function useDeskView(): DeskViewValue {
  const value = use(DeskViewContext);
  if (!value) {
    throw new Error("useDeskView must be used inside <DeskViewProvider>.");
  }
  return value;
}
